module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textcontainer"
  }, [_c('h2', [_vm._v("Non-Academic Writings")]), _vm._v(" "), _vm._l((_vm.commentary.orderedcategories), function(category) {
    return _c('div', [_c('h4', [_vm._v(_vm._s(category))]), _vm._v(" "), _c('table', [_c('col', {
      staticStyle: {
        "width": "7%"
      }
    }), _vm._v(" "), _c('col', {
      staticStyle: {
        "width": "60%"
      }
    }), _vm._v(" "), _c('col', {
      staticStyle: {
        "width": "30%"
      }
    }), _vm._v(" "), _c('tbody', _vm._l((_vm.catsort(_vm.commentary.articles)), function(article) {
      return (article.category == category) ? _c('tr', [_c('td', [_vm._v(_vm._s(article.month + '/' + article.year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('td', [_c('a', {
        attrs: {
          "href": article.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(article.publisher))])])]) : _vm._e()
    }))])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e16d32e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/writing.vue
// module id = 206
// module chunks = 0